<template>
  <div>
    <title-bar title="单位节能预估统计表">
      <el-button @click="$router.back()" icon="fa fa-angle-left">返回</el-button>
    </title-bar>
    <div class="page-body">
      <el-form v-model="queryForm" inline>
        <el-form-item label="单位">
          <comp-select v-model="queryForm.compIds" multiple collapse-tags style="width: 300px"></comp-select>
        </el-form-item>
        <el-form-item label="统计年月">
          <el-date-picker v-model="queryForm.startYearMonth" type="month"
                          :clearable="false"
                          value-format="yyyyMM"
                          style="width: 140px"
                          clearable
                          format="yyyy年MM月"></el-date-picker>
          至
          <el-date-picker v-model="queryForm.endYearMonth" type="month"
                          :clearable="false"
                          value-format="yyyyMM"
                          style="width: 140px"
                          clearable
                          format="yyyy年MM月"></el-date-picker>
        </el-form-item>
        <el-form-item label="新风预估功率">
          <el-input-number v-model="queryForm.fanPower" :min="0" :controls="false">
            <template slot="append">W</template>
          </el-input-number>
        </el-form-item>
        <el-form-item label="空调预估功率">
          <el-input-number v-model="queryForm.acPower" :min="0" :controls="false">
            <template slot="append">W</template>
          </el-input-number>
        </el-form-item>
        <el-form-item label="预估电费">
          <el-input-number v-model="queryForm.powerPrice" :min="0" :controls="false">
            <template slot="append">元</template>
          </el-input-number>
        </el-form-item>
        <el-button type="primary" icon="fa fa-search" :loading="loading" @click="query">查询</el-button>
      </el-form>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="compName" label="单位名称" min-width="180"></el-table-column>
        <el-table-column label="新风能耗" align="center">
          <el-table-column prop="fanRunHours" label="运行（小时）" align="center" min-width="90"></el-table-column>
          <el-table-column prop="fanPower" label="能耗（KWH）" align="center" min-width="90"></el-table-column>
<!--          <el-table-column prop="fanMoney" label="费用（元）" align="center" min-width="90"></el-table-column>-->
        </el-table-column>
        <el-table-column label="空调能耗" align="center">
          <el-table-column prop="acRunHours" label="运行（小时）" align="center" min-width="90"></el-table-column>
          <el-table-column prop="acPower" label="能耗（KWH）" align="center" min-width="90"></el-table-column>
<!--          <el-table-column prop="acMoney" label="费用（元）" align="center" min-width="90"></el-table-column>-->
        </el-table-column>
        <el-table-column label="总能耗" align="center">
          <el-table-column prop="totalPower" label="能耗（KWH）" align="center" min-width="90"></el-table-column>
<!--          <el-table-column prop="totalMoney" label="费用（元）" align="center" min-width="90"></el-table-column>-->
        </el-table-column>
        <el-table-column label="预估节能" align="center">
          <el-table-column prop="savePower" label="节能（KWH）" align="center" min-width="90"></el-table-column>
<!--          <el-table-column prop="saveMoney" label="节电费用（元）" align="center" min-width="120"></el-table-column>-->
          <el-table-column prop="savePct" label="节电率（%）" align="center" min-width="90">
            <template slot-scope="{row, $index}">
              <span>{{ (row.savePower/(row.savePower+row.totalPower)*100).toFixed(1) }} </span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CompSelect from "@/components/base/CompSelect.vue";
export default {
  components: {CompSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      years: [],
      queryForm: {
        compIds: null,
        startYearMonth: new Date().getFullYear()+"01",
        endYearMonth: new Date().format("yyyyMM"),
        fanPower: 300,
        acPower: 2200,
        powerPrice: 0.75,
        page: 1,
        limit: 10
      },
      total: 0,
      records: []
    }
  },
  created() {
    for(let i=new Date().getFullYear();i>=2019;i--) {
      this.years.push(i);
    }
    this.query();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/report/savingPowerReport", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped>

</style>